// extracted by mini-css-extract-plugin
export var searchHeader = "_8a-0";
export var searchHeaderDark = "_8a-1";